<template>
    <div class="modal-card" id="draggable" >
        <header class="modal-card-head pop-header">
            <p class="modal-card-title tit">
                보안물품 등록
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
            <div class="inner-box">
                <table class="visit-info-table">
                    <colgroup>
                        <col width="35%"></col>
                        <col width="*"></col>
                    </colgroup>
                    <tr>
                        <td class="tit">사용목적</td>
                        <td><input class="input" type="text" ref="useContents" v-model="useContents" style="width:100%"></td>
                    </tr>
                </table>

                <div class="visit-item-list">
                    <div class="visit-item-list_header mobile_hide">
                        <ul>
                            <li class="list_1">
                                <p class="tit">
                                    <span>반입자</span>
                                </p>
                            </li>
                            <li class="list_2">
                                <p class="tit">
                                    <span>자산구분</span>
                                </p>
                            </li>
                            <li class="list_3">
                                <p class="tit">
                                    <span>반출입</span>
                                </p>
                            </li>
                            <li class="list_4">
                                <p class="tit">
                                    <span>구분</span>
                                </p>
                            </li>
                            <li class="list_5">
                                <p class="tit">
                                    <span>삭제</span>
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ul v-for="(row, index) in Items">
                        <li class="list_1">
                            <p class="tit m_show">
                                <span>반입자</span>
                            </p>
                            <div class="write">
                                {{childVisitNm}}
                            </div>
                        </li>
                        <li class="list_2">
                            <p class="tit m_show">
                                <span>자산구분</span>
                            </p>
                            <div class="write">
                                <select v-model="row.visitorAssetCd">
                                    <option
                                            v-for="code in visitorAssetCds"
                                            :key="code.key"
                                            :value="code.key"
                                            v-text="code.value"/>
                                </select>
                            </div>
                        </li>
                        <li class="list_3">
                            <p class="tit m_show">
                                <span>반출입</span>
                            </p>
                            <div class="write">
                                <select v-model="row.takeOfOut">
                                    <option
                                            v-for="code in takeOfOutCds"
                                            :key="code.key"
                                            :value="code.key"
                                            v-text="code.value"/>
                                </select>
                            </div>
                        </li>
                        <li class="list_4">
                            <p class="tit m_show">
                                <span>구분</span>
                            </p>
                            <div class="write">
                                <select v-model="row.visitorCategoryCd">
                                    <option
                                            v-for="code in visitorCategoryCds"
                                            :key="code.key"
                                            :value="code.key"
                                            v-text="code.value"/>
                                </select>
                            </div>
                        </li>
                        <li class="list_5">
                            <p class="tit m_show">
                                <span>삭제</span>
                            </p>
                            <div class="write">
                                <button class="button-delete" @click="removeRow(index)">삭제</button>
                            </div>
                        </li>
                    </ul>
                </div>

                <div style="margin:20px 10px 0 0;text-align: right">
                    <button class="button-add" @click="addRow">물품추가</button>
                </div>

                <br><br>
                <button class="button-request" @click="save">
                    등록
                </button>
                <button class="button-close" @click="$parent.close()">
                    닫기
                </button>

            </div>
        </section>
    </div>
</template>

<script>
    import Vue from "vue";
    import _ from "lodash";

    export default {

        name: "secuItem",
        props: {
            childVisitNm: {
                type: String,
                required: true
            },
            visitorSeq: {
                type: Number,
                required: true
            },
            childPersonItems: {
                type: Array,
                required: false
            },
            compCd: {
                type: String,
                required: true
            },
        },

        data() {
            return {
                title: "보안물품등록",
                VisitNm : this.childVisitNm,
                useContents:"",
                visitorAssetCds: [],
                takeOfOutCds: [],
                visitorCategoryCds: [],

                Items: [
                    {
                        visitorAssetCd: "",
                        takeOfOut: "",
                        visitorCategoryCd: "",
                        modelNm: "",
                        serialNm: ""
                    }
                ]
            }
        },
        methods: {
            save() {
                if(this.useContents==""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '사용목적을 입력해주세요.'}).then(() => {
                        })
                    ,10})
                    this.$refs.useContents.focus();
                    return false;
                }

                let visitItemData = {
                    visitorSeq : this.visitorSeq,
                    useContents : this.useContents,
                    items : this.Items,
                }

               this.$swal({type: 'info', text: this.VisitNm + ' 사용자의 보안물품 내역이 등록되었습니다.'});
               this.$emit('close', visitItemData)
               this.closeModal();

            },

            closeModal() {
                this.$parent.close();
            },

            addRow() {
                this.Items.push({
                    visitorAssetCd: this.visitorAssetCds[0].key,
                    takeOfOut: this.takeOfOutCds[0].key,
                    visitorCategoryCd: this.visitorCategoryCds[0].key,
                    modelNm: "",
                    serialNm: ""
                });
            },

            getVisitorAssetCdCombo() {
                this.$http.get(`/api/code/combo`, { params: { compCd: this.compCd, groupCd: "VISITOR_ASSET_CD" } })
                    .then(response => {
                        this.visitorAssetCds = response.data;
                        this.Items[0].visitorAssetCd = this.visitorAssetCds[0].key;
                }).finally(()=>{
                    let cnt = 0;
                    for(var i=0; i <this.childPersonItems.length; i++) {
                        if(this.visitorSeq == this.childPersonItems[i].visitorSeq){
                            this.Items[cnt].visitorAssetCd = this.childPersonItems[i].visitorAssetCd;
                            cnt++;
                        }
                    }
                });
            },

            getTakeOfOutCdCombo() {
                this.$http.get(`/api/code/combo`, { params: { compCd: this.compCd, groupCd: "TAKE_OUT_CD" } })
                    .then(response => {
                        this.takeOfOutCds = response.data;
                        this.Items[0].takeOfOut = this.takeOfOutCds[0].key;
                }).finally(()=>{
                    let cnt = 0;
                    for(var i=0; i <this.childPersonItems.length; i++) {
                        if(this.visitorSeq == this.childPersonItems[i].visitorSeq){
                            this.Items[cnt].takeOfOut = this.childPersonItems[i].takeOfOut;
                            cnt++;
                        }
                    }
                });
            },

            getVisitorCategoryCdCombo() {
                this.$http.get(`/api/code/combo`, { params: { compCd: this.compCd, groupCd: "VISITOR_CATEGORY_CD" } })
                    .then(response => {
                        this.visitorCategoryCds = response.data;
                        this.Items[0].visitorCategoryCd = this.visitorCategoryCds[0].key;
                    }).finally(()=>{
                        let cnt = 0;
                        for(var i=0; i <this.childPersonItems.length; i++) {
                            if(this.visitorSeq == this.childPersonItems[i].visitorSeq){
                                this.Items[cnt].visitorCategoryCd = this.childPersonItems[i].visitorCategoryCd;
                                cnt++;
                            }
                        }
                });
            },

            removeRow(index) {
                if(this.Items.length == 1){
                    this.$swal({type: 'warning', text: '해당 항목은 삭제 할 수 없습니다.'});
                    return false;
                } else {
                    this.Items.splice(index, 1);
                }
            },

            getVisitorItemSet() {
                let sflag = false;
                for(var i=0; i <this.childPersonItems.length; i++) {
                    if(this.visitorSeq == this.childPersonItems[i].visitorSeq){
                        sflag = true;
                    }
                }

                if(sflag == true){
                    this.Items = [];
                }

                for(var i=0; i <this.childPersonItems.length; i++) {
                    if(this.visitorSeq == this.childPersonItems[i].visitorSeq){
                        this.useContents = this.childPersonItems[i].useContents;
                        this.Items.push({
                            visitorAssetCd: this.childPersonItems[i].visitorAssetCd,
                            takeOfOut: this.childPersonItems[i].takeOfOut,
                            visitorCategoryCd: this.childPersonItems[i].visitorCategoryCd,
                            modelNm: this.childPersonItems[i].modelNm,
                            serialNm: this.childPersonItems[i].serialNm,
                        });
                    }
                }
            },
        },

        mounted() {
            this.getVisitorAssetCdCombo();
            this.getTakeOfOutCdCombo();
            this.getVisitorCategoryCdCombo()
            this.getVisitorItemSet();
        },
    }
</script>
<style>
    .inner-box{
        height: 100%;
        width:100%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    .inner-box button{
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
        font-weight: bold;
    }

    .inner-box .button-request{
        background-color: #023e7c;
        color:#fff;
        width:100px;
    }

    .inner-box .button-close{
        background-color: #b3b3b3;
        color:#fff;
        width:100px;
        margin-left:10px;
    }

    .inner-box .button-add{
        background-color: #3f3f3f;
        color:#fff;
        width:100px;
    }

    .inner-box .button-delete{
        background-color: #ad1b1b;
        color:#fff;
        width:50px;
    }

    .visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    .visit-info-table td {
        border-bottom: 1px solid #ddd;
        border-left:0px;
        color: #999;
        padding: 15px 0 15px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    .visit-info-table td input{
        width: 35%;
        height: 40px;
    }

    .visit-info-table td p input{
        width: 100%;
    }

    .visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    .visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    .visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    .visit-info-table td.list-c{
        text-align: center;
    }

    .visit-info-table td button{
        margin-left:10px;
    }

    .mobile_hide {
        display: none;
    }

    .visit-item-list {
        margin-top:30px;
    }
    .visit-item-list ul{
        border-top: 1px solid #333;
        border-right: 0px;
        border-left: 0px;
    }

    .visit-item-list ul li {
        float: none;
        display: table;
        table-layout: fixed;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .visit-item-list ul li input{
        height:40px;
    }

    .visit-item-list ul li select{
        width:100%;
        padding:10px 25px 10px 15px;
    }

    .visit-item-list ul li .tit.m_show {
        display: table-cell;
    }

    .visit-item-list ul li .tit {
        padding-left: 10px;
        color: #666;
        background: #f9f9f9;
        display: table-cell;
        width: 35%;
        vertical-align: middle;
        font-size: 14px;
    }

    .visit-item-list ul li .write {
        /*display: table-cell;*/
        text-align: center;
        padding: 10px 0 10px 10px;
        vertical-align: middle;
        font-size: 13px;
    }

    .modal table {
        border:0px;
        border-top: 1px solid #333;
    }

    .modal table tr th, .modal table tr td {
        border-left: 0px;
    }

    .modal-card {
        width:100%;
    }

    .modal-content, .modal-card {
        margin: 0px;
        max-height: calc(100vh);
    }

    @media (min-width: 1000px) {
        .modal-card {
            width:850px;
        }

        .mobile_hide {
            display: inline;
        }

        .visit-item-list ul li .tit.m_show {
            display: none;
        }

        .visit-item-list ul {
            border-top: 0px;
            display: table;
            table-layout: fixed;
            width: 100%;
        }

        .visit-item-list .visit-item-list_header ul {
            border-top: 1px solid #333;
            display: table;
            table-layout: fixed;
            width: 100%;
        }

        .visit-item-list .visit-item-list_header ul li {
            display: table-cell;
            float: none;
            vertical-align: middle;
            padding: 15px 0;
        }

        .visit-item-list ul li {
            overflow: hidden;
            border-bottom: 1px solid #ddd;
            display: table-cell;
            width: 8%;
            text-align: center;
            vertical-align: middle;
        }

        .visit-item-list ul li .tit {
            color: #333;
            line-height: normal;
            background: #ffffff;
            font-size: 13px;
            width: 24%;
        }

        .visit-item-list ul li .write {
            text-align: center;
        }

        .visit-item-list ul li.list_1 {
            width: 17%;
        }

        .visit-item-list ul li.list_2 {
            width: 25%;
        }

        .visit-item-list ul li.list_3 {
            width: 22%;
        }

        .visit-item-list ul li.list_4 {
            width: 21%;
        }

        .visit-item-list ul li.list_5 {
            width: 15%;
        }

        .visit-item-list ul li.list_6 {
            width: 22%;
        }

        .visit-item-list ul li.list_7 {
            width: 8%;
        }
    }
</style>
